import * as React from "react";
import { NavLink, Outlet } from "react-router";

import { SETTINGS_SECTIONS } from "@/components/layout/SettingsShell";
import { cn } from "@/lib/cn";

/**
 * MV2-985 — requested restyle of the segmented pill tab strip from the
 * pre-MV2-865 mobile settings screen, in place of the current card-list
 * index. 4 columns, not the old 3 — that version dropped Notifications
 * from mobile nav entirely, which MV2-865 explicitly fixed; this fork
 * keeps that fix while restoring the requested look. Forked so a future
 * web redesign of the shared SettingsShell can't silently break this too.
 */
export function SettingsShell(): React.ReactElement {
  return (
    <div className="h-full overflow-y-auto">
      <div className="flex flex-col gap-3 px-4 pb-24 pt-4">
        <div>
          <div className="type-eyebrow">Settings</div>
          <h1 className="mt-0.5 text-xl font-semibold text-gray-900">Your account</h1>
        </div>

        <nav
          aria-label="Settings sections"
          className="grid grid-cols-4 gap-1 rounded-xl bg-[color:var(--gray-100)] p-1"
        >
          {SETTINGS_SECTIONS.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center gap-0.5 rounded-lg py-2 text-center text-[11px] font-medium transition-colors",
                  isActive
                    ? "bg-[color:var(--gray-0)] text-[color:var(--action)] shadow-sm"
                    : "text-gray-500 active:text-gray-700",
                )
              }
            >
              <s.icon size={17} aria-hidden />
              {s.label}
            </NavLink>
          ))}
        </nav>

        <Outlet />
      </div>
    </div>
  );
}
